import { render } from "./reset-password.vue?vue&type=template&id=62f3cac7"
import script from "./reset-password.vue?vue&type=script&lang=js"
export * from "./reset-password.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/auth/reset-password.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "62f3cac7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('62f3cac7', __exports__)) {
    console.log('reload')
    api.reload('62f3cac7', __exports__)
  }
  
  module.hot.accept("./reset-password.vue?vue&type=template&id=62f3cac7", () => {
    console.log('re-render')
    api.rerender('62f3cac7', render)
  })

}


export default __exports__